import Component from '../inherited/Component';

export default class Klaviyo extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx);
    }

    mount() {
        let form = document.getElementById('klaviyo-form');
        let subscribedText = document.getElementById(
            'klaviyo__subscribed-text'
        );
        form.addEventListener('submit', function (e) {
            e.preventDefault(); //stop form from submitting

            let email = e.target[0].value;
            let variant = e.target.dataset.variant;

            fetch('https://a.klaviyo.com/api/v1/catalog/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `a=R25LDx&email=${email}&variant=${variant}&platform=shopify`,
            })
                .then(function (response) {
                    if (response.ok) {
                        return response.json();
                    }
                    return Promise.reject(response);
                })
                .then(function (data) {
                    console.log('success', data);
                })
                .catch(function (error) {
                    console.warn('Something went wrong.', error);
                });

            subscribedText.style.opacity = 1;
            subscribedText.style.height = 'auto';
        });
    }
}
